import { useEffect, useState } from "react";
import { getGenericResearchQueryDetail } from "../services/ResearchQueriesService";

interface IuseFetchResearchQuery {
  setIsLoading: any;
  currentRQId: any;
  isFromExecution: boolean;
}
const useFetchGenericResearchQueryById = ({
  setIsLoading,
  currentRQId,
  isFromExecution,
}: IuseFetchResearchQuery) => {
  const [genericResearchQueryDetail, setGenericResearchQueryDetail] =
    useState<any>({});
  useEffect(() => {
    if (currentRQId && currentRQId > 0 && !isFromExecution) {
      setIsLoading(true);
      const getResearchQueryData = async () => {
        try {
          const result = await getGenericResearchQueryDetail(currentRQId);
          setGenericResearchQueryDetail(result);
        } catch (err) {
          setGenericResearchQueryDetail({});
        } finally {
          setIsLoading(false);
        }
      };
      getResearchQueryData();
    }
  }, [currentRQId]);

  return [genericResearchQueryDetail];
};

export default useFetchGenericResearchQueryById;
